{% block sw_extension_store_slider %}
    <div
        class="sw-extension-store-slider sw-meteor-card"
        :class="[
            cardClasses,
            `sw-extension-store-slider__slides-count-${usedSlideCount}`
        ]"
    >
        {% block sw_extension_store_slider_slides %}
            <div ref="movingImageWrapper" class="sw-extension-store-slider__slides">
                {% block sw_extension_store_slider_loader %}
                    <div v-if="!images" class="sw-extension-store-slider__loader">
                        <sw-loader />
                    </div>
                {% endblock %}

                <template v-else>
                    {% block sw_extension_store_slider_slide_item %}
                        <div
                            v-for="img, key in images"
                            :key="key"
                            class="sw-extension-store-slider__slide-item"
                            :class="slideClasses(key)"
                            :data-key="key"
                            :style="getActiveStyle(key)"
                        >
                            <img :src="img">
                        </div>
                    {% endblock %}
                </template>
            </div>
        {% endblock %}

        {% block sw_extension_store_slider_navigation %}
            <div v-if="images.length > usedSlideCount" class="sw-extension-store-slider__navigation">
                {% block sw_extension_store_slider_navigation_inner %}
                    <button class="sw-extension-store-slider__btn-back" :disabled="isDisabledPrevious" @click="previous()">
                        {% block sw_extension_store_slider_navigation_inner_icon_left %}
                            <mt-icon name="regular-chevron-left" size="20" />
                        {% endblock %}
                    </button>

                    <button class="sw-extension-store-slider__btn-next" :disabled="isDisabledNext" @click="next()">
                        {% block sw_extension_store_slider_navigation_inner_icon_right %}
                            <mt-icon name="regular-chevron-right" size="20" />
                        {% endblock %}
                    </button>
                {% endblock %}
            </div>
        {% endblock %}
    </div>
{% endblock %}
